import { render, staticRenderFns } from "./EditPaymentTerm.vue?vue&type=template&id=480d0419&scoped=true&"
import script from "./EditPaymentTerm.vue?vue&type=script&lang=js&"
export * from "./EditPaymentTerm.vue?vue&type=script&lang=js&"
import style0 from "./EditPaymentTerm.vue?vue&type=style&index=0&id=480d0419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d0419",
  null
  
)

component.options.__file = "EditPaymentTerm.vue"
export default component.exports